import React from "react"

export default function Rating({ className, ratingNumber }) {
    // Ensure ratingNumber is a number between 0 and 5
    const rating = Math.min(Math.max(Number(ratingNumber) || 0, 0), 5)
    
    return (
        <div className={className} data-rating={rating}>
            <i className="cs_center">
                <i className="fa-solid fa-star"></i>
            </i>
            <i className="cs_center">
                <i className="fa-solid fa-star"></i>
            </i>
            <i className="cs_center">
                <i className="fa-solid fa-star"></i>
            </i>
            <i className="cs_center">
                <i className="fa-solid fa-star"></i>
            </i>
            <i className="cs_center">
                <i className="fa-solid fa-star"></i>
            </i>
            <div className="cs_rating_percentage" style={{ width: `${rating * 20}%` }}>
                <i className="cs_center">
                    <i className="fa-solid fa-star" style={{ color: '#ffc107' }}></i>
                </i>
                <i className="cs_center">
                    <i className="fa-solid fa-star" style={{ color: '#ffc107' }}></i>
                </i>
                <i className="cs_center">
                    <i className="fa-solid fa-star" style={{ color: '#ffc107' }}></i>
                </i>
                <i className="cs_center">
                    <i className="fa-solid fa-star" style={{ color: '#ffc107' }}></i>
                </i>
                <i className="cs_center">
                    <i className="fa-solid fa-star" style={{ color: '#ffc107' }}></i>
                </i>
            </div>
        </div>
    )
}